export const allowedLangOptions = [
    { value: "hu", label: "Magyar", iso: "HU" },
    { value: "en", label: "English", iso: "EN" },
    { value: "sk", label: "Slovenský", iso: "SK" },
    { value: "cz", label: "Čeština", iso: "CZ" },
    { value: "de", label: "Deutsch", iso: "DE" },
    { value: "fr", label: "Français", iso: "FR" },
    { value: "pl", label: "Polski", iso: "PL" },
    { value: "si", label: "Slovenščina", iso: "SI" },
    { value: "hr", label: "Hrvatski", iso: "HR" },
    { value: "ro", label: "Română", iso: "RO" },
    { value: "es", label: "Español", iso: "ES" },
    { value: "ru", label: "Русский", iso: "RU" },
    { value: "uk", label: "Українська", iso: "UK" },
    { value: "he", label: "עברית", iso: "HE" },
    { value: "ja", label: "日本語", iso: "JA" },
    { value: "ko", label: "한국어", iso: "KO" },
];